module.exports = __webpack_public_path__ + "img/china2.38ae867d.jpg";